import React, { useContext, useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import LanguageContext from "../../utils/Contexts/LanguageContext";

function generatePaginationOptions(recordsFiltered) {
  if (recordsFiltered < 10) return [recordsFiltered]; // [9], [8], etc.
  if (recordsFiltered < 15) return [10, recordsFiltered]; // e.g. [10, 12]
  if (recordsFiltered < 20) return [10, 15, recordsFiltered]; // e.g. [10, 15, 17]
  return [10, 15, 20]; // 20 or more
}

function TablePagination({
  recordsFiltered,
  setPageCount,
  pageCount,
  activePage,
  setActivePage,
}) {
  const { t } = useContext(LanguageContext);

  const paginationOptions = generatePaginationOptions(recordsFiltered);

  const [selectValue, setSelectValue] = useState(null);

  useEffect(() => {
    let fallback;

    if (recordsFiltered < 15) {
      fallback = recordsFiltered;
    } else {
      fallback = 15;
    }

    setSelectValue(fallback);
  }, [recordsFiltered]);

  return (
    <div className="card-footer">
      <div className="d-flex justify-content-center flex-wrap flex-sm-nowrap justify-content-sm-between gap-4">
        <div className="col-sm mb-2 mb-sm-0">
          <div className="item-count-dropdown d-flex justify-content-center justify-content-sm-start align-items-center">
            <span className="me-2">{t("Showing")}:</span>

            <div className="tom-select-custom">
              <select
                id="datatableEntries"
                className="form-select form-select-borderless w-auto"
                autoComplete="off"
                value={selectValue}
                onChange={(e) => {
                  const newValue = parseInt(e.target.value);
                  setSelectValue(newValue); // update select UI
                  setPageCount(newValue); // apply pagination size
                  setActivePage(1); // optionally reset to first page
                }}
              >
                {paginationOptions?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <span className="text-secondary me-2">{t("of")}</span>
            <span id="datatableWithPaginationInfoTotalQty">
              {recordsFiltered}
            </span>
          </div>
        </div>

        <div className="col-sm-auto">
          <div className="d-flex justify-content-center justify-content-sm-end">
            {recordsFiltered > pageCount ? (
              <Pagination
                activePage={activePage}
                itemsCountPerPage={pageCount}
                totalItemsCount={recordsFiltered}
                pageRangeDisplayed={window.innerWidth < 600 ? 3 : 5} // Show only 3 pages on small screens
                onChange={(pageNumber) => setActivePage(pageNumber)}
                prevPageText={
                  window.innerWidth < 600 ? (
                    <i
                      className={`bi bi-chevron-left ${
                        activePage > 1 ? "text-white" : "text-muted"
                      }`}
                    ></i>
                  ) : (
                    t("Prev")
                  )
                }
                nextPageText={
                  window.innerWidth < 600 ? (
                    <i
                      className={`bi bi-chevron-right ${
                        activePage < Math.ceil(recordsFiltered / pageCount)
                          ? "text-white"
                          : "text-muted"
                      }`}
                    ></i>
                  ) : (
                    t("Next")
                  )
                }
                innerClass="pagination datatable-custom-pagination"
                itemClass="paginate_item page-item"
                linkClass="paginate_button page-link"
                linkClassPrev="previous"
                linkClassNext="next"
                hideFirstLastPages
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TablePagination;
